import { IRanchWellViewModel } from '../ranch-settings/interfaces';
import { ILotEdit } from '../ranch-settings/modals/lot/interfaces';
import { IRanchCreateFertilizerForm } from '../ranch-settings/modals/fertilizer/interfaces';
import { ICommodityTypeFormResult } from '../../models/commodity-type/interfaces';
import { ISoilLayer } from '../../models/soil-type/interfaces';

export namespace RanchCreation {

	export namespace Form {
		export interface IRanchDetails {
			Name: string;
			Acres: number;
			Coordinates: string;
			SpatialETAvailable: boolean;
			WeatherAPI_Id: number;
		}

		export interface IWeatherStation {
			StationId: number;
			Name: string;
			Distance?: number;
			Priority: number;
		}

		/** Wizard form value (internal). Mapped to RanchCreation.IPayload before POST. */
		export interface IParentForm {
			RanchDetails: IRanchDetails;
			PlantingAreas: ILotEdit[];
			WeatherStations: IWeatherStation[];
			Wells: IRanchWellViewModel[];
			Fertilizers: IRanchCreateFertilizerForm[];
			CommodityTypes: ICommodityTypeFormResult[];
		}
	}

	export interface IFertilizerNutrient {
		NutrientId: number;
		Percentage: number;
	}

	export interface IFertilizer {
		IsPrivate: boolean;
		Id?: number;
		Name?: string;
		FormulationTypeId?: number;
		PoundsPerGallon?: number;
		Nutrients?: IFertilizerNutrient[];
	}

	export interface ICommodityType {
		CommodityTypeId: number;
		CropTypeIds: number[];
	}

	export interface IPlantingArea {
		Name: string;
		Acres: number;
		Coordinates: string;
		ObstructionDepth?: number;
		SoilLayers: ISoilLayer[];
	}

	export interface IWell {
		Name: string;
		ElectricalConductivity?: number;
		NitrogenPPM: number;
	}

	export interface IRanch {
		Name: string;
		Acres: number;
		Coordinates: string;
		SpatialETAvailable: boolean;
		WeatherAPI_Id: number;
	}

	/** Clean POST body for ranch create API. */
	export interface IPayload {
		Ranch: IRanch;
		PlantingAreas: IPlantingArea[];
		WeatherStationIds: number[];
		Wells: IWell[];
		Fertilizers: IFertilizer[];
		CommodityTypes: ICommodityType[];
	}
}

/**
 * Enum used to identify the form key for each step of the create ranch wizard
 */
export enum RanchCreateStepFormKeys {
	RanchDetails = 'RanchDetails',
	PlantingAreas = 'PlantingAreas',
	Fertilizers = 'Fertilizers',
	WeatherStations = 'WeatherStations',
	Wells = 'Wells',
	CommodityTypes = 'CommodityTypes'
}
